/**
 * Debug logger for the socket/connection layer.
 *
 * Enabled by setting a flag in localStorage:
 *   localStorage.setItem('canvas-debug-socket', 'true')
 *
 * Disabled by removing it:
 *   localStorage.removeItem('canvas-debug-socket')
 *
 * All log lines are prefixed with [CANVAS-SOCKET-DEBUG] for easy filtering
 * in the browser DevTools console.
 */

const DEBUG_KEY = 'canvas-debug-socket';

function isEnabled(): boolean {
  try {
    return localStorage.getItem(DEBUG_KEY) === 'true';
  } catch {
    return false;
  }
}

export function debugLog(message: string, ...args: unknown[]): void {
  if (isEnabled()) {
    console.log(`[CANVAS-SOCKET-DEBUG] ${message}`, ...args);
  }
}

export function debugWarn(message: string, ...args: unknown[]): void {
  if (isEnabled()) {
    console.warn(`[CANVAS-SOCKET-DEBUG] ${message}`, ...args);
  }
}
